module.exports = __webpack_public_path__ + "static/img/ques.474fceb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/ques.png
// module id = PGmP
// module chunks = 1